<template>
  <div id="app" class="admin">
    <Menu/>
    <ShowVideo v-if="user.role === 'business' && user.profile.indexOf('show') > -1" />
    <router-view class="admin-router"/>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Menu from './Menu.vue'
import ShowVideo from './ShowVideo.vue'

export default {
  components: {
    Menu,
    ShowVideo
  },
  computed: {
    ...mapState(['user'])
  }
}
</script>
